import lazyComRecarga from "lib/lazyComRecarga";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import TopBackground from "components/TopBackground";
import ProtectedRoute from "components/ProtectedRoute";
import Page404 from "pages/Page404";
import Login from "pages/Login";

// Telas internas carregadas sob demanda: o login não baixa o código delas (selects, datepicker, alertas)
const Menu = lazyComRecarga(() => import("pages/Menu"));
const Individuais = lazyComRecarga(() => import("pages/atividades/Individuais"));
const Coletivas = lazyComRecarga(() => import("pages/atividades/Coletivas"));
const Pregador = lazyComRecarga(() => import("pages/atividades/Pregador"));
const Registros = lazyComRecarga(() => import("pages/atividades/Registros"));
const Diacono = lazyComRecarga(() => import("pages/atividades/Diacono"));
const SemUnidade = lazyComRecarga(() => import("pages/SemUnidade"));

const router = createBrowserRouter([
  {
    path: "/",
    element: <TopBackground />,
    children: [
      { path: "/", element: <Login /> },
      { path: "/menu", element: <ProtectedRoute element={<Menu />} /> },
      { path: "/individuais", element: <ProtectedRoute element={<Individuais />} /> },
      { path: "/coletivas", element: <ProtectedRoute element={<Coletivas />} /> },
      { path: "/pregador", element: <ProtectedRoute element={<Pregador />} /> },
      { path: "/registros", element: <ProtectedRoute element={<Registros />} /> },
      { path: "/diacono", element: <ProtectedRoute element={<Diacono />} /> },
      { path: "/sem-unidade", element: <ProtectedRoute element={<SemUnidade />} /> },
      { path: "*", element: <Page404 /> },
    ],
  },
], {
  future: {
    v7_startTransition: true, // Ativa a transição antecipadamente
  },
});

function App() {
  return <RouterProvider router={router} />;
}

export default App;
